import MathGenerator from "./MathGenerator";

export default class LinksGenerator {
    // Public:
    constructor(cParams) {
        this.saveParams(cParams);
        this.createThicknessFunction(cParams.thicknessSettings);
        this.createOpacityFunction();
    }

    compute(links) {
        let svg = this._svg;
        let opacityFunc = this._opacityFunc;
        let thicknessFunc = d => this._thicknessFunc(d.value);
        this._func = svg
            .append("g")
            .attr("class", "links")
            .selectAll("line")
            .data(links)
            .enter()
            .append("line")
            .attr("stroke", d => d.color)
            .attr("stroke-opacity", opacityFunc)
            .attr("stroke-width", thicknessFunc);
        return this._func;
    }

    // Private:
    saveParams(cParams) {
        this._svg = cParams.svg;
        this._colorParams = cParams.color;
        this._opacities = cParams.opacities;
    }

    createThicknessFunction(cParams) {
        let mathGen = new MathGenerator(cParams);
        let func = mathGen.compute();
        this._thicknessFunc = func;
    }

    createOpacityFunction() {
        let opacities = this._opacities;
        let soloOpacity = opacities.solo;
        let clusterOpacity = opacities.cluster;
        let sharedOpacity = opacities.shared;
        let func = function(d) {
            let category = d.category;
            switch (category) {
                case "solo":
                    return soloOpacity;
                case "cluster":
                    return clusterOpacity;
                case "shared":
                    return sharedOpacity;
                default:
                    console.error("Invalid category.");
                    break;
            }
        };
        this._opacityFunc = func;
    }
}
